<template>
    <resources-base-table
        :inputs="inputs"
        :headers="headers"
        :items="areas"
        :editedItem="editedItem"
        :defaultItem="defaultItem"
        :modelService="areasService"
    >
        <template v-slot:form="{ localEditedItem, afterDialogOpen }">
            <span v-for="field in inputs" :key="field.value">
                <models-areas-field
                    :field="field"
                    :localEditedItem="localEditedItem"
                    :afterDialogOpen="afterDialogOpen"
                ></models-areas-field>
            </span>
        </template>
        <template v-slot:actions="{ item }">
            <router-link :to="{ name: 'carreraGenerica', params: { id: item.id } }">
                <v-icon small>carreras</v-icon>
            </router-link>
        </template>
    </resources-base-table>
</template>

<script>
import { AreasService } from "../../../services/carreras-api.service"

export default {
    data: () => ({
        areasService: AreasService,
        inputs: [
            {
                sortable: false,
                text: "Área",
                value: "area"
            }
        ],
        headers: [
            {
                sortable: false,
                text: "ID",
                value: "id"
            },
            {
                sortable: false,
                text: "Área",
                value: "area"
            },
            { text: "Acciones", value: "action", sortable: false }
        ],
        editedItem: {
            area: ""
        },
        defaultItem: {
            area: ""
        }
    }),
    props: ["areas"],
    watch: {}
}
</script>
